import type { Components, Theme } from "@mui/material/styles";

export const MuiDialogActions: Components<Theme>["MuiDialogActions"] = {
  defaultProps: {
    disableSpacing: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      gap: theme.spacing(1),
      justifyContent: "space-between",
      margin: theme.spacing(0, 3),
      padding: theme.spacing(2, 0, 3),
    }),
  },
};
